export class Subscription {
  id: string;
  clientId: string;
  type: string;
  active: boolean;
  startDate: Date;
  endDate: Date;
  paymentId: string;
  rateLimit: number;
  rateConsumed: number;
  creditsConsumed: number;
  serviceIds: string[];
  firstConsumption: Date;
  lastConsumption: Date;
  comments: string;
  created_at: Date;
  updated_at: Date;
  orderId: string;
  orderLineId: string;
  crmOrderId: string;
  partnerId: string;
  renewal: {
    newSubscription: string;
    keepStudents: boolean;
    status: string;
  };

  valid: boolean;
}
